export default __webpack_public_path__ + "static/PANASAS_Incorrect-Use-C-6cd5a60ef07cd42002d776e2eaaeb84f.jpg";